import React, {useState} from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from "./components/Home";
import About from "./components/About";
import NavScroll from "./components/NavScroll";
/*import Skills from "./components/Skills";*/
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import NotFound from "./components/NotFound";
import Research from "./components/Research";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Toggle dark mode
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };


  return (
    <Router>
      <div className="App">
          {/* Navigation Bar */}
          <NavScroll toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} />
          <Routes>
            <Route exact path="/" element={<Home isDarkMode={isDarkMode} />} />
            <Route path="/about" element={<About isDarkMode={isDarkMode} />} />
            {/* <Route path="/skills" element={<Skills isDarkMode={isDarkMode} />} /> */}
            <Route path="/projects" element={<Projects isDarkMode={isDarkMode} />} />
            <Route path="/contact" element={<Contact isDarkMode={isDarkMode} />} />
            <Route path="/research" element={<Research isDarkMode={isDarkMode} />} />
            <Route path="*" element={<NotFound />} /> {/* Catch-all Route */}
          </Routes>
      </div>
    </Router>
  );
}

export default App;
